var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgModalForbidden(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52 0C41.7154 0 31.6617 3.04975 23.1104 8.76358C14.559 14.4774 7.89404 22.5987 3.95829 32.1005C0.0225306 41.6022 -1.00724 52.0577 0.999189 62.1447C3.00562 72.2317 7.95814 81.4972 15.2305 88.7695C22.5028 96.0419 31.7683 100.994 41.8553 103.001C51.9423 105.007 62.3978 103.977 71.8995 100.042C81.4013 96.106 89.5226 89.441 95.2364 80.8896C100.95 72.3383 104 62.2846 104 52C104 38.2087 98.5214 24.9823 88.7696 15.2304C79.0177 5.47856 65.7913 0 52 0V0ZM52 97.5C43.001 97.5 34.204 94.8315 26.7216 89.8318C19.2391 84.8322 13.4073 77.7261 9.9635 69.4121C6.51972 61.098 5.61866 51.9495 7.37429 43.1234C9.12992 34.2972 13.4634 26.1899 19.8267 19.8266C26.1899 13.4633 34.2973 9.1299 43.1234 7.37427C51.9495 5.61864 61.0981 6.51969 69.4121 9.96348C77.7261 13.4073 84.8323 19.2391 89.8319 26.7215C94.8315 34.204 97.5 43.0009 97.5 52C97.5 64.0673 92.7063 75.6404 84.1734 84.1733C75.6405 92.7062 64.0674 97.5 52 97.5Z",
    fill: "#00CC99"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85.044 18.7815L15.1765 78.649L15.364 78.869C14.7423 78.3365 13.9425 78.0583 13.1246 78.0899C12.3066 78.1215 11.5307 78.4606 10.9519 79.0394C10.3731 79.6182 10.034 80.3941 10.0024 81.2121C9.97083 82.03 10.249 82.8298 10.7815 83.4515L10.5615 83.2315C11.1652 83.8358 11.882 84.3152 12.6711 84.6424C13.4602 84.9695 14.306 85.1378 15.1602 85.1378C16.0144 85.1378 16.8603 84.9695 17.6493 84.6424C18.4384 84.3152 19.1553 83.8358 19.759 83.2315L89.6265 23.364C90.1589 22.7423 90.4371 21.9425 90.4055 21.1246C90.3739 20.3066 90.0349 19.5307 89.4561 18.9519C88.8773 18.3731 88.1013 18.034 87.2834 18.0024C86.4655 17.9708 85.6657 18.2491 85.044 18.7815Z",
    fill: "#00CC99"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalForbidden);
export default __webpack_public_path__ + "static/media/modal__forbidden.05d637dc.svg";
export { ForwardRef as ReactComponent };